import { adaptationTypeValues, type AdaptationType } from "@/types/adaptation";
import type { CachedAsset } from "./AssetCacheSchema";

/**
 * A cached adaptation pathway action stored in IndexedDB.
 *
 * `full.metadata` already carries the analysis inputs, but which asset the
 * action belongs to — and which run produced it — lives only on the
 * `adaptation_pathway_actions` row. Storing them here is what lets a warm load
 * rebuild the list straight from the cache instead of re-reading that table.
 */
export interface CachedAdaptation extends CachedAsset {
  portfolio_asset_id: string;
  adaptation_type: AdaptationType;
}

/**
 * Whether a cached record carries a usable adaptation identity.
 *
 * Records written before those fields existed, and baseline results mirrored in
 * by an older `AssetDataLoader`, are missing them and need one backfill pass.
 */
export const hasAdaptationIdentity = (cached: CachedAdaptation): boolean =>
  typeof cached.portfolio_asset_id === "string" && adaptationTypeValues.includes(cached.adaptation_type);
